const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_name_contains",
      label: "Client",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agent_name_contains",
      label: "Agent",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itinerary_ref_contains",
      label: "Itinerary Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "internal_ref_contains",
      label: "Internal Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Inv Number",
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "iti_start_date",
      label: "Itinerary start date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "iti_end_date",
      label: "Itinerary end date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "created_at",
      label: "Created at date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberComparatorFilter"),
    props: {
      filterName: "amount",
      label: "Amount",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "approved_eq",
      label: "Full Invoice",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "exported_eq",
      label: "Exported",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "invoicedByName_contains",
      label: "Invoiced by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itiBookedBy_contains",
      label: "Iti Booked by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destination_id",
      label: "Supplier Destination",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "destination_name_contains",
      label: "Destination Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/ItineraryStatusFilter"),
    props: {
      filterName: "itineraryStatuses_eq",
      label: "Itinerary Status",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/sales-invoices/sales-invoices-filters.js